// src/components/JobCreate.js

import React from 'react';
import { useParams } from 'react-router-dom'; // 1. Import useParams
import JobAddEdit from "./JobAddEdit";

const JobCreate = () => {
  // 2. Get the `postFor` parameter from the URL
  const { postFor } = useParams(); 

  return (
    <div className="overflow-y w-full">
      {/* 3. Pass it as a prop to JobAddEdit */}
      <JobAddEdit postFor={postFor} />
    </div>
  );
};

export default JobCreate;